import React from 'react'



const Footer = () => {


  return (
    <div className='myfooter'>
    <footer className="padding_4x">
    <div className="flexme">
    
    <section></section>
      <section className="flex-content padding_1x">
        <h3>Mentors</h3>
        <a href="https://www.linkedin.com/in/dr-sachin-gajjar-805816a/">Dr Sachin Gajjar</a>
        <a href="https://www.linkedin.com/in/jayesh-patel-8582b61b/">Dr Jayesh Patel</a>
      </section>
      <section className="flex-content padding_1x">
        <a href="https://forms.gle/NaWFgcwHM547QcFb7" target='_blank'>
        <button class="contactButton"> Feedback
        <div class="iconButton">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"></path><path fill="currentColor" d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"></path></svg>
        </div>
      </button>
      </a>
      </section>
      <section className="flex-content padding_1x">
        <h3>Developers</h3>
        <a href="https://www.linkedin.com/in/dhruv-dholariya-814aaa201/">Dhruv Dholariya - [ 20BEC024 ]</a>
        <a href="https://www.linkedin.com/in/siddharth-agarwal-a6b50b12a/">Siddharth Aggarwal - [ 20BEC119 ]</a>
        <a href="https://www.linkedin.com/in/aditya-jha-727029204/">Aditya Jha - [ 20BEC005 ]</a>

      </section>
     
    </div>
    <div className="flex">

    <section className="flex-content padding_1x">
      <p>Copyright ©2023 All rights reserved || EC Department @Nirma University</p>
    </section>

    



<section></section>
<section></section>

<section></section>

    <section className="flex-content padding_1x">
      <a href="https://www.youtube.com/@projectsatdepartmentofecen2577"><i className="fa fa-youtube fa-2x"></i></a>

      <a href="linkedin.com/company/ec-it-nu/"><i className="fa fa-linkedin fa-2x"></i></a>

    </section>

   
    
    
  
    


    <section >
        
    </section>
  </div>

  
  </footer>
  
  </div>
  )
}

export default Footer